module.exports = __webpack_public_path__ + "media/images/contact/savannah-68d98e61bf65b76647ffa72bd9c32bf4.jpg";